module.exports = __webpack_public_path__ + "img/A.e1b52381.png";